// global/subscription/subscription.lib

function subscritionChannelFromList(btn) {
    var subscribed = $(btn).hasClass('btn-verde');
    $.post(subscribed ? global_tokyvideo_api_channel_unsubscribe_list : global_tokyvideo_api_channel_subscribe_list,
        {
            'channelId': $(btn).data('channel-id')
        },
        function (response) {
            if ((response['error'] == true) && (response['alert'] == true)) {
                alertWeb(response['message'], response['message_type']);
            } else if (response['result'] == 'ok') {
                var spanText = $(btn).find('.texto').first();
                if (subscribed) {
                    $(btn).removeClass('btn-verde').addClass('btn-naranja');
                    $(spanText).text($(spanText).data('text-subscribe'));
                    if ($(btn).closest('.box-thumb-channel').find('.n-subscriptions').text().indexOf("k") < 0) {
                        var count = (parseInt($(btn).closest('.box-thumb-channel').find('.n-subscriptions').text().replace(/\,/g, "").replace(/\./g, "")) - 1).toLocaleString("es");
                        $(btn).closest('.box-thumb-channel').find('.n-subscriptions').text(count);
                    }
                } else {
                    $(btn).removeClass('btn-naranja').addClass('btn-verde');
                    $(spanText).text($(spanText).data('text-subscribed'));
                    if ($(btn).closest('.box-thumb-channel').find('.n-subscriptions').text().indexOf("k") < 0) {
                        var count = (parseInt($(btn).closest('.box-thumb-channel').find('.n-subscriptions').text().replace(/\,/g, "").replace(/\./g, "")) + 1).toLocaleString("es");
                        $(btn).closest('.box-thumb-channel').find('.n-subscriptions').text(count);
                    }
                }
            }
        },
        'json'
    );
}

function unfollow(btn) {
    $.post(global_tokyvideo_api_serie_unfollow_list,
        {
            'serieId': $(btn).data('serie-id')
        },
        function (response) {
            if ((response['error'] === true) && (response['alert'] === true)) {
                alertWeb(response['message'], response['message_type']);
            } else if (response['result'] === 'ok') {
                var followersText = $('.num_followers').text();
                if (!followersText.match(/[a-z]/i)) {
                    var followers = parseInt(followersText.trim());
                    $('.num_followers').text(--followers);
                }
                $(btn).removeClass('is-active');
                $(btn).attr('data-after', $(btn).data('follow'));
            }
        },
        'json'
    );
}

function follow(btn) {
    $.post(global_tokyvideo_api_serie_follow_list,
        {
            'serieId': $(btn).data('serie-id')
        },
        function (response) {
            if ((response['error'] === true) && (response['alert'] === true)) {
                alertWeb(response['message'], response['message_type']);
            } else if (response['result'] === 'ok') {
                var followersText = $('.num_followers').text();
                if (!followersText.match(/[a-z]/i)) {
                    var followers = parseInt(followersText.trim());
                    $('.num_followers').text(++followers);
                }
                $(btn).addClass('is-active');
                $(btn).attr('data-after', $(btn).data('unfollow'));
            }
        },
        'json'
    );
}

function changeSubscriptionSerieFromList(btn, modal) {
    var following = $(btn).hasClass('is-active');

    if (following) {
        modal.show();
    } else {
        follow(btn);
    }
    // unfollow(following, btn);
}
